module.exports = __webpack_public_path__ + "img/circle-dots.795ecca9.svg";